import { render, staticRenderFns } from "./indexReports.vue?vue&type=template&id=03404e24&"
import script from "./indexReports.vue?vue&type=script&lang=ts&"
export * from "./indexReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports